import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { Row, Col } from 'react-bootstrap';
import TextField from 'material-ui/TextField';

export default class ValidateEmail extends Component {

    constructor(props) {
        super(props);
        this.submitOtp = this.submitOtp.bind(this);
        this.otp = null;
    }
    // submit otp
    submitOtp(e) 
    {
        e.preventDefault();
        if(this.otp.input.value)
        {
            this.props.verifyOtp(this.otp.input.value);
        }
    }


    render() {
        const actionsOther = [

            <RaisedButton
                label="Change Email"
                primary={true}
                className="submit-otp"
                labelStyle={{'color': '#fff'}}
                keyboardFocused={true}
                onClick={this.props.cancelClick}
            />,
            <RaisedButton
                label="Submit"
                primary={true}
                labelStyle={{ 'color': '#fff' }}
                keyboardFocused={true}
                className="submit-otp"
                type='Submit'
                onClick={this.submitOtp}
            />,
        ];

        return (
            <Dialog
                actions={actionsOther}
                className="model-other"
                modal={false}
                contentClassName="otp-overlay"
                open={this.props.open}
                onRequestClose={this.handleClose}
            >
                <div className="other-popup-content">
                    <form name="loginForm" onSubmit={this.submitOtp}>
                        <h3>Please enter your One Time Password sent to your email address:</h3>
                        <div className="popup-data">
                            <Row>
                                <Col md={12}>
                                    <TextField
                                        hintText="OTP"
                                        fullWidth={true}
                                        floatingLabelText="OTP"
                                        type="text"
                                        name="otp"
                                        ref={(element) => { this.otp = element }}
                                        required={true}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </form>
                </div>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/ValidateEmail.js